import { render, staticRenderFns } from "./estadisticas.vue?vue&type=template&id=16c42d98&scoped=true&"
import script from "./estadisticas.vue?vue&type=script&lang=ts&"
export * from "./estadisticas.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas.vue?vue&type=style&index=0&id=16c42d98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c42d98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
